/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetDetailsForFCCActivitySummaryReport,
    GetVCCFactoriesByGroupID,
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetDetailsForFCCActivitySummaryReport(model) {
    const response = await CommonPost('/api/FCCActivitySummaryReport/GetDetailsForFCCActivitySummaryReport', null, model);
    return response.data;
}

